import * as React from 'react';

import { PageContainerWithData } from './PageContainerWithData';

import { useSelector } from 'react-redux';
import { selectFormData } from '../../selectors/selectFormData';
import { selectWithIntroScreen } from '../../selectors/selectWithIntroScreen';

export function PageContainer() {
  const formData = useSelector(selectFormData);
  const withIntroScreen = useSelector(selectWithIntroScreen);

  if (!formData) {
    /** TODO если нет данных - выбросить экран ошибки */
    return null;
  }

  return <PageContainerWithData formData={formData} withIntroScreen={withIntroScreen} />;
}
